import { render } from "./Zip.vue?vue&type=template&id=0f965f2c"
import script from "./Zip.vue?vue&type=script&lang=js"
export * from "./Zip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__